<template>
    <div class="container-fluid">
        <section v-if="isSourceEMonitoring">
            <div class="row">
                <div class="col-12">
                    <div class="card card-form">
                        <div class="card-header">
                            <div class="row">
                                <div class="col">
                                    <div class="pull-left">
                                        <h4 class="card-title float-left" v-if="realEstate.id">
                                            {{$t("realEstate.view.eAppraisalTitle")}}
                                            ({{$t(realEstate.category === 'Residential' ?
                                            'realEstate.category.residential.label' :
                                            'realEstate.category.notorious.label')}})</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="alert alert-warning d-flex"  v-if="realEstate.status === 'Pending'">
                                        <i class="fa-fw fa fa-warning mr-1"></i>
                                        <label style="color: #4d2600; font-size: 14px"><strong>Янги! </strong> Кўчмас мулк маълумотларини кўриб баҳоловчига беринг.</label>
                                    </div>
                                    <div class="alert alert-danger" v-if="realEstate.status === 'Rejected'">
                                        <strong>Бекор қилинган!</strong> Баҳолаш жараёни бекор қилинган...
                                    </div>
                                    <div class="alert alert-success d-flex"  v-if="realEstate.status === 'AssignedToEvaluator'">
                                        <i class="fa-fw fa fa-check mr-1"></i>
                                        <label style="color: #4d2600; font-size: 14px"><strong>Баҳолаш жараёни! </strong> Кўчмас мулкни баҳоловчи баҳолаяпти.</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col d-flex">
                                    <button class="all-btn add-btn"
                                            v-if="realEstate.status === 'Pending' && hasPermission('E_BAHOLASH_REAL_ESTATE_BIND_APPRAISER') && !isCadastreFixError"
                                            @click="applyAppraisal('AssignedToEvaluator')"
                                    >
                                        <i class="fa fa-check"></i>
                                        <span>{{$t("realEstate.action.bindAppraiser")}}</span>
                                    </button>
                                    <button class="all-btn delete-btn ml-2"
                                            v-if="realEstate.status === 'Pending' && hasPermission('E_BAHOLASH_REAL_ESTATE_REJECT')"
                                            @click="showReject"
                                    >
                                        <i class="fa fa-reply"></i>
                                        <span>{{$t("realEstate.action.pending")}}</span>
                                    </button>
                                   <button class="all-btn edit-btn ml-2"
                                          v-if="realEstate.status === 'Pending' && !isCadastreFixError"
                                          @click="sendFixError"
                                  >
                                      <i class="fa fa-warning"></i>
                                      <span>{{$t("realEstate.plus.sendFixError.title")}}</span>
                                  </button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.ownerClient")}}</label>
                                        <div class="form-control">
                                            <div v-if="realEstate && realEstate.owner">
                                                <strong>{{ realEstate.owner.fullName }}</strong>
                                                <span> - {{ realEstate.owner.firmName }} </span>
                                                <span class="badge badge-primary" v-if="realEstate.owner.type === 'Legal'"> Юридик шахс</span>
                                                <span class="badge badge-primary" v-else> Жисмоний шахс</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.name")}}</label>
                                        <div class="form-control">
                                            <span>{{ realEstate.name }}</span>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.evaluationPurpose")}}</label>
                                        <div class="form-control">
                                            <div v-if="realEstate.evlGoalType === 'Predge'">Гаровга қўйиш</div>
                                            <div v-else-if="realEstate.evlGoalType === 'Sale'">Сотиш учун</div>
                                            <div v-else-if="realEstate.evlGoalType === 'Zero'">0 кийматда хусусийлаштириш</div>
                                            <div v-else-if="realEstate.evlGoalType === 'DeterminingValue'">Бозор қийматини аниқлаш</div>
                                            <div v-else-if="realEstate.evlGoalType === 'Investment'">Инвестиция қийматини аниқлаш</div>
                                            <div v-else-if="realEstate.evlGoalType === 'Privatization'">Хусусийлаштириш</div>
                                            <div v-else-if="realEstate.evlGoalType === 'FormationStatutoryFund'">Устав жамғармасини шакллантириш</div>
                                            <div v-else-if="realEstate.evlGoalType === 'BusinessDeterminingValue'">Бизнес қийматини аниқлаш</div>
                                            <div v-else-if="realEstate.evlGoalType === 'AcceptToBalance'">Балансга кабул килиш</div>
                                            <div v-else-if="realEstate.evlGoalType === 'Losses'">Етказилган зарар(сотиш)</div>
                                            <div v-else-if="realEstate.evlGoalType === 'DeterminationValue'">Қийматини аниқлаш</div>
                                        </div>
                                    </div>
                                </div>
                                <div class=" col-12 col-md-6">
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.propertyType")}}</label>
                                        <div class="form-control">
                                            <div v-if="realEstate.evlPropertyType === 'Private'">Хусусий мулк</div>
                                            <div v-else-if="realEstate.evlPropertyType === 'Government'">Давлат мулки</div>
                                            <div v-else-if="realEstate.evlPropertyType === 'Society'">Жамият мулки</div>
                                            <div v-else>Жамоа мулки</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.createdDate")}}</label>
                                        <div class="form-control">{{ new Date(realEstate.createdDate) | dateFormat('DD.MM.YYYY') }}</div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.createdBy")}}</label>
                                        <div class="form-control h-100">
                                            <div v-if="realEstate && realEstate.createdBy && realEstate.createdBy.name">
                                                {{ realEstate.createdBy.name }}
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="realEstate.status === 'Rejected'" class="form-group">
                                        <label>{{$t("realEstate.field.rejectText")}}</label>
                                        <div class="form-control h-100">
                                            <div v-if="realEstate && realEstate.reasonDesc">
                                                {{ realEstate.reasonDesc }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group" v-if="!isOrgTypeMib">
                                        <label>{{$t("realEstate.field.contractAmount")}}</label>
                                        <numeric-input v-model="realEstate.evlContractAmount"
                                                       :controls="false" :precision="2"
                                                       :min="120000"
                                        >
                                        </numeric-input>
                                    </div>

                                    <div class="form-group" v-if="!isOrgTypeMib && isOwnerTypeLegal">
                                        <label>Олдиндан тўлов фоизи 0% дан 100% гача!</label>
                                        <numeric-input class="form-control" v-model="realEstate.prepayment"
                                                       :controls="false" :precision="2">
                                        </numeric-input>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.locationText")}}</label>
                                        <real-estate-location-map :realEstateId="realEstate.id" v-model="target" :dataSource="realEstate.target"/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="section-header">
                                        <h4>{{$t("realEstate.field.docsSubmitted")}}</h4>
                                    </div>
                                </div>
                                <template v-if="realEstate.evlGoalType">

                                    <template v-if="isOwnerTypePhysical">
                                        <PreviewDropZone
                                                code="passportDropZone"
                                                label="realEstate.field.docPassport"
                                                :data="realEstate.passport"
                                                @change="(files) => {realEstate.passport = files}"
                                        />
                                        <PreviewDropZone
                                                code="applicationDropZone"
                                                label="realEstate.field.docApplication"
                                                :data="realEstate.applicationForm"
                                                @change="(files) => {realEstate.applicationForm = files}"
                                        />
                                    </template>
                                    <PreviewDropZone
                                            code="documentsDropZone"
                                            label="realEstate.field.docDocuments"
                                            :data="realEstate.documents"
                                            @change="(files) => {realEstate.documents = files}"
                                    />
                                    <PreviewDropZone
                                            code="cadastreDropZone"
                                            label="realEstate.field.docCadastre"
                                            :data="realEstate.cadastre"
                                            @change="(files) => {realEstate.cadastre = files}"
                                    />
                                    <template v-if="isOwnerTypeLegal">
                                        <PreviewDropZone code="privatizationLetterDropZone"
                                                         label="realEstate.field.docPrivatizationLetter"
                                                         :data="realEstate.privatizationLetter"
                                                         @change="(files) => {realEstate.privatizationLetter = files}"
                                        />
                                        <PreviewDropZone
                                                code="privatizationCommissionOrderDropZone"
                                                label="realEstate.field.docPrivatizationCommissionOrder"
                                                :data="realEstate.privatizationCommissionOrder"
                                                @change="(files) => {realEstate.privatizationCommissionOrder = files}"
                                        />
                                        <PreviewDropZone
                                                code="ownershipCertificateDropZone"
                                                label="realEstate.field.docOwnershipCertificate"
                                                :data="realEstate.ownershipCertificate"
                                                @change="(files) => {realEstate.ownershipCertificate = files}"
                                        />
                                    </template>

                                    <template v-if="isOwnerTypeLegal && isOrgTypeMib">
                                        <PreviewDropZone
                                                code="actOfSaleDropZone"
                                                label="realEstate.field.docActOfSale"
                                                :data="realEstate.actOfSale"
                                                @change="(files) => {realEstate.actOfSale = files}"
                                        />
                                        <PreviewDropZone
                                                code="decisionDropZone"
                                                label="realEstate.field.docDecision"
                                                :data="realEstate.decision"
                                                @change="(files) => {realEstate.decision = files}"
                                        />
                                        <PreviewDropZone
                                                code="playlistDropZone"
                                                label="realEstate.field.docPlaylist"
                                                :data="realEstate.playlist"
                                                @change="(files) => {realEstate.playlist = files}"
                                        />
                                        <PreviewDropZone
                                                code="balanceDropZone"
                                                label="realEstate.field.docBalance"
                                                :data="realEstate.balance"
                                                @change="(files) => {realEstate.balance = files}"
                                        />
                                        <!-- :has-error="$v.realEstate.balance.$error"-->
                                    </template>
                                </template>
                                <div class="col-12">
                                  <RealEstateDropZone code="realEstatePhotoDropZone"
                                                      folder="Building"
                                                      label="building.field.photosToSubmit"
                                                      acceptedFiles="image/*"
                                                      view="BUILDING" :data="realEstate.photos"
                                                      @change="(photos) => {realEstate.photos = photos}"
                                                      :removeFile="canRemoveFile"
                                                      :editable="canSave"
                                  />
                                </div>
                            </div>
                            <div class="row" v-if="realEstate.id && realEstate.id > 0">
                                <div class="col-12">
                                    <div class="section-header">
                                        <h4 class="pull-left">
                                            {{$t("realEstate.field.buildingDocsSubmitted")}}
                                        </h4>
                                    </div>
                                    <div v-for="(building, index) in realEstate.buildings" :key="building.id">
                                        <div class="section-header">{{ index + 1}} - бино маълумотлари</div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>{{$t("building.field.name")}}</label>
                                                <div class="form-control">{{ building.name }}</div>
                                            </div>
                                        </div>
                                        <RealEstateDropZone :code="`buildingPhotoDropZone_${index + 1}`" folder="Building"
                                                            label="building.field.photosToSubmit"
                                                            view="BUILDING" :data="building.photos"
                                                            @change="(photos) => {building.photos = photos}"
                                                            :has-error="$v.realEstate.buildings.$each[index].photos.$error"
                                                            :removeFile="canRemoveFile"
                                                            :editable="canSave"
                                        />
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>{{$t("building.field.description")}}</label>
                                                <div class="form-control">{{ building.description }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-5">
                              <div class="col-12 btns-box">
                                <button class="all-btn add-btn" @click="save" :disabled="processing"
                                        v-if="canSave">{{$t("action.save")}}
                                </button>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template>
                <b-modal v-model="show" title="Кўчмас мулкни бекор қилиш">
                    <div class="container-fluid">
                        <div class="form-group">
                            <label>Бекор қилиш сабабини киритинг<span class="red">*</span></label>
                            <textarea class="form-control"
                                      v-model="realEstate.reasonDesc">
                        </textarea>
                        </div>
                    </div>
                    <div slot="modal-footer">
                        <button
                                type="button"
                                  class="all-btn add-btn float-right ml-2"
                                @click="rejectAppraisal('Rejected')"
                        >{{$t("action.save")}}
                        </button>
                        <button
                                type="button"
                                class="all-btn delete-btn float-right"
                                @click="rejectModalHide"
                        >{{$t("action.cancel")}}
                        </button>
                    </div>
                </b-modal>
            </template>
            <CadastreFixErrorModal :error-msg="$t('realEstate.plus.sendFixError.description')"
                                   :request-id="this.realEstate.requestId"
                                   :evl-object-type="'Building'"
                                   :requiredIdent="false"
                                   @handle-success="handleFixErrorSuccess"
            />
        </section>
        <section v-else-if="realEstate.status !== 'NotReady'">
            <div class="row">
                <div class="col-12">
                    <div class="card card-form">
                        <div class="card-header">
                            <div class="row">
                                <div class="col">
                                    <div class="pull-left">
                                        <h4 class="card-title float-left" v-if="realEstate.id">
                                            {{$t("realEstate.view.eAppraisalTitle")}}
                                            ({{$t(realEstate.category === 'Residential' ?
                                            'realEstate.category.residential.label' :
                                            'realEstate.category.notorious.label')}})</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="alert alert-warning d-flex"  v-if="realEstate.status === 'Pending'">
                                        <i class="fa-fw fa fa-warning mr-1"></i>
                                        <label style="color: #4d2600; font-size: 14px"><strong>Янги! </strong> Кўчмас мулк маълумотларини кўриб баҳоловчига беринг.</label>
                                    </div>
                                    <div class="alert alert-danger" v-if="realEstate.status === 'Rejected'">
                                        <strong>Бекор қилинган!</strong> Баҳолаш жараёни бекор қилинган...
                                    </div>
                                    <div class="alert alert-success d-flex"  v-if="realEstate.status === 'AssignedToEvaluator'">
                                        <i class="fa-fw fa fa-check mr-1"></i>
                                        <label style="color: #4d2600; font-size: 14px"><strong>Баҳолаш жараёни! </strong> Кўчмас мулкни баҳоловчи баҳолаяпти.</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col d-flex">
                                    <button class="all-btn add-btn"
                                            v-if="realEstate.status === 'Pending' && hasPermission('E_BAHOLASH_REAL_ESTATE_BIND_APPRAISER') && !isCadastreFixError"
                                            @click="applyAppraisal('AssignedToEvaluator')"
                                    >
                                        <i class="fa fa-check"></i>
                                        <span>{{$t("realEstate.action.bindAppraiser")}}</span>
                                    </button>
                                    <button class="all-btn delete-btn ml-2"
                                            v-if="realEstate.status === 'Pending' && hasPermission('E_BAHOLASH_REAL_ESTATE_REJECT')"
                                            @click="showReject"
                                    >
                                        <i class="fa fa-reply"></i>
                                        <span>{{$t("realEstate.action.pending")}}</span>
                                    </button>
                                    <!--  <button class="all-btn delete-btn ml-2"
                                              v-if="realEstate.status === 'Pending' && hasPermission('E_BAHOLASH_REAL_ESTATE_DELETE')"
                                              @click="deletedRealEstate"
                                      >
                                          <i class="fa fa-remove"></i>
                                          {{$t("realEstate.delete.title")}}
                                      </button> -->
<!--                                  && hasPermission('E_BAHOLASH_REAL_ESTATE_SEND_FIX_ERROR')-->
                                   <button class="all-btn edit-btn ml-2"
                                          v-if="realEstate.status === 'Pending' && !isCadastreFixError"
                                          @click="sendFixError"
                                  >
                                      <i class="fa fa-warning"></i>
                                      <span>{{$t("realEstate.plus.sendFixError.title")}}</span>
                                  </button>


                                  <button class="all-btn edit-btn ml-2"
                                          v-if="realEstate.status === 'Pending'"
                                          @click="showCadastreDetail"
                                  >
                                    <i class="fa fa-home"></i>
                                    <span>{{ $t("realEstate.cadastreDetails.title") }}</span>
                                  </button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.ownerClient")}}</label>
                                        <div class="form-control">
                                            <div v-if="realEstate && realEstate.owner">
                                                <strong>{{ realEstate.owner.fullName }}</strong>
                                                <span> - {{ realEstate.owner.firmName }} </span>
                                                <span class="badge badge-primary" v-if="realEstate.owner.type === 'Legal'"> Юридик шахс</span>
                                                <span class="badge badge-primary" v-else> Жисмоний шахс</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.name")}}</label>
                                        <div class="form-control">
                                            <span>{{ realEstate.name }}</span>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.evaluationPurpose")}}</label>
                                        <div class="form-control">
                                            <div v-if="realEstate.evlGoalType === 'Predge'">Гаровга қўйиш</div>
                                            <div v-else-if="realEstate.evlGoalType === 'Sale'">Сотиш учун</div>
                                            <div v-else-if="realEstate.evlGoalType === 'Zero'">0 кийматда хусусийлаштириш</div>
                                            <div v-else-if="realEstate.evlGoalType === 'DeterminingValue'">Бозор қийматини аниқлаш</div>
                                            <div v-else-if="realEstate.evlGoalType === 'Investment'">Инвестиция қийматини аниқлаш</div>
                                            <div v-else-if="realEstate.evlGoalType === 'Privatization'">Хусусийлаштириш</div>
                                            <div v-else-if="realEstate.evlGoalType === 'FormationStatutoryFund'">Устав жамғармасини шакллантириш</div>
                                            <div v-else-if="realEstate.evlGoalType === 'BusinessDeterminingValue'">Бизнес қийматини аниқлаш</div>
                                            <div v-else-if="realEstate.evlGoalType === 'AcceptToBalance'">Балансга кабул килиш</div>
                                            <div v-else-if="realEstate.evlGoalType === 'Losses'">Етказилган зарар(сотиш)</div>
                                            <div v-else-if="realEstate.evlGoalType === 'DeterminationValue'">Қийматини аниқлаш</div>
                                        </div>
                                    </div>
                                </div>
                                <div class=" col-12 col-md-6">
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.propertyType")}}</label>
                                        <div class="form-control">
                                            <div v-if="realEstate.evlPropertyType === 'Private'">Хусусий мулк</div>
                                            <div v-else-if="realEstate.evlPropertyType === 'Government'">Давлат мулки</div>
                                            <div v-else-if="realEstate.evlPropertyType === 'Society'">Жамият мулки</div>
                                            <div v-else>Жамоа мулки</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.createdDate")}}</label>
                                        <div class="form-control">{{ new Date(realEstate.createdDate) | dateFormat('DD.MM.YYYY') }}</div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.createdBy")}}</label>
                                        <div class="form-control h-100">
                                            <div v-if="realEstate && realEstate.createdBy && realEstate.createdBy.name">
                                                {{ realEstate.createdBy.name }}
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="realEstate.status === 'Rejected'" class="form-group">
                                        <label>{{$t("realEstate.field.rejectText")}}</label>
                                        <div class="form-control h-100">
                                            <div v-if="realEstate && realEstate.reasonDesc">
                                                {{ realEstate.reasonDesc }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group" v-if="!isOrgTypeMib">
                                        <label>{{$t("realEstate.field.contractAmount")}}</label>
                                        <numeric-input v-model="realEstate.evlContractAmount"
                                                       :controls="false" :precision="2"
                                                       :min="120000"
                                        >
                                        </numeric-input>
                                    </div>

                                    <div class="form-group" v-if="!isOrgTypeMib && isOwnerTypeLegal">
                                        <label>Олдиндан тўлов фоизи 0% дан 100% гача!</label>
                                        <numeric-input class="form-control" v-model="realEstate.prepayment"
                                                       :controls="false" :precision="2">
                                        </numeric-input>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.locationText")}}</label>
                                        <real-estate-location-map :realEstateId="realEstate.id" v-model="target" :dataSource="realEstate.target"/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="section-header">
                                        <h4>{{$t("realEstate.field.docsSubmitted")}}</h4>
                                    </div>
                                </div>
                                <template v-if="realEstate.evlGoalType">

                                    <template v-if="isOwnerTypePhysical">
                                        <PreviewDropZone
                                                code="passportDropZone"
                                                label="realEstate.field.docPassport"
                                                :data="realEstate.passport"
                                                @change="(files) => {realEstate.passport = files}"
                                        />
                                        <PreviewDropZone
                                                code="applicationDropZone"
                                                label="realEstate.field.docApplication"
                                                :data="realEstate.applicationForm"
                                                @change="(files) => {realEstate.applicationForm = files}"
                                        />
                                    </template>
                                    <PreviewDropZone
                                            code="documentsDropZone"
                                            label="realEstate.field.docDocuments"
                                            :data="realEstate.documents"
                                            @change="(files) => {realEstate.documents = files}"
                                    />
                                    <PreviewDropZone
                                            code="cadastreDropZone"
                                            label="realEstate.field.docCadastre"
                                            :data="realEstate.cadastre"
                                            @change="(files) => {realEstate.cadastre = files}"
                                    />
                                    <template v-if="isOwnerTypeLegal">
                                        <PreviewDropZone code="privatizationLetterDropZone"
                                                         label="realEstate.field.docPrivatizationLetter"
                                                         :data="realEstate.privatizationLetter"
                                                         @change="(files) => {realEstate.privatizationLetter = files}"
                                        />
                                        <PreviewDropZone
                                                code="privatizationCommissionOrderDropZone"
                                                label="realEstate.field.docPrivatizationCommissionOrder"
                                                :data="realEstate.privatizationCommissionOrder"
                                                @change="(files) => {realEstate.privatizationCommissionOrder = files}"
                                        />
                                        <PreviewDropZone
                                                code="ownershipCertificateDropZone"
                                                label="realEstate.field.docOwnershipCertificate"
                                                :data="realEstate.ownershipCertificate"
                                                @change="(files) => {realEstate.ownershipCertificate = files}"
                                        />
                                    </template>

                                    <template v-if="isOwnerTypeLegal && isOrgTypeMib">
                                        <PreviewDropZone
                                                code="actOfSaleDropZone"
                                                label="realEstate.field.docActOfSale"
                                                :data="realEstate.actOfSale"
                                                @change="(files) => {realEstate.actOfSale = files}"
                                        />
                                        <PreviewDropZone
                                                code="decisionDropZone"
                                                label="realEstate.field.docDecision"
                                                :data="realEstate.decision"
                                                @change="(files) => {realEstate.decision = files}"
                                        />
                                        <PreviewDropZone
                                                code="playlistDropZone"
                                                label="realEstate.field.docPlaylist"
                                                :data="realEstate.playlist"
                                                @change="(files) => {realEstate.playlist = files}"
                                        />
                                        <PreviewDropZone
                                                code="balanceDropZone"
                                                label="realEstate.field.docBalance"
                                                :data="realEstate.balance"
                                                @change="(files) => {realEstate.balance = files}"
                                        />
                                        <!-- :has-error="$v.realEstate.balance.$error"-->
                                    </template>
                                </template>
                            </div>
                            <div class="row" v-if="realEstate.id && realEstate.id > 0">
                                <div class="col-12">
                                    <div class="section-header">
                                        <h4 class="pull-left">
                                            {{$t("realEstate.field.buildingDocsSubmitted")}}
                                        </h4>
                                    </div>
                                    <div v-for="(building, index) in realEstate.buildings" :key="building.id">
                                        <div class="section-header">{{ index + 1}} - бино маълумотлари</div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>{{$t("building.field.name")}}</label>
                                                <div class="form-control">{{ building.name }}</div>
                                            </div>
                                        </div>
                                        <PreviewDropZoneEAppraisal
                                                code="buildingPhotoDropZone"
                                                label="realEstate.field.docBuildingPhotos"
                                                :data="building.photos"
                                                @change="(photos) => {building.photos = photos}"
                                        />
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>{{$t("building.field.description")}}</label>
                                                <div class="form-control">{{ building.description }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template>
                <b-modal v-model="show" title="Кўчмас мулкни бекор қилиш">
                    <div class="container-fluid">
                        <div class="form-group">
                            <label>Бекор қилиш сабабини киритинг<span class="red">*</span></label>
                            <textarea class="form-control"
                                      v-model="realEstate.reasonDesc">
                        </textarea>
                        </div>
                    </div>
                    <div slot="modal-footer">
                        <button
                                type="button"
                                  class="all-btn add-btn float-right ml-2"
                                @click="rejectAppraisal('Rejected')"
                        >{{$t("action.save")}}
                        </button>
                        <button
                                type="button"
                                class="all-btn delete-btn float-right"
                                @click="rejectModalHide"
                        >{{$t("action.cancel")}}
                        </button>
                    </div>
                </b-modal>
            </template>
            <CadastreFixErrorModal :error-msg="$t('realEstate.plus.sendFixError.description')"
                                   :request-id="this.realEstate.requestId"
                                   :evl-object-type="'Building'"
                                   :requiredIdent="false"
                                   @handle-success="handleFixErrorSuccess"
            />
        </section>
        <section v-else-if="realEstate.status === 'NotReady'">
            <div class="row">
                <div class="col-12">
                    <div class="card card-form">
                        <div class="card-header">
                            <div class="row">
                                <div class="col">
                                    <button class="all-btn add-btn"
                                            v-if="hasPermission('E_BAHOLASH_REAL_ESTATE_BIND_AGENT') &&
                                            (!realEstate.createdBy || realEstate.createdBy.id)"
                                            @click="bindAgent()"
                                    >
                                        <i class="fa fa-check"></i>
                                        {{$t("realEstate.action.bindAgent")}}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>{{$t("report.field.agents")}}</label>
                                        <v-select v-model="realEstate.createdBy" label="text"
                                                  :options="agents"
                                                  :filterable="false"
                                                  @search="onUsersSearch"
                                                  @search:focus="onUsersFocus">
                                            <template slot="option" slot-scope="option" v-if="option">
                                                <div v-html="option.name"></div>
                                            </template>
                                            <template slot="selected-option"
                                                      v-if="realEstate && realEstate.createdBy && realEstate.createdBy.name">
                                                <div v-html="realEstate.createdBy.name"
                                                     @click="$eventBus.$emit('search:focus')"></div>
                                            </template>
                                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                        </v-select>
                                        <div class="red" v-if="$v.realEstate.createdBy.$error">
                                            {{$t("realEstate.field.agent")}}
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("fitment.province")}}</label>
                                        <div class="form-control">
                                            <div v-if="realEstate && realEstate.province">
                                                <strong>{{ realEstate.province.name }}</strong>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("report.field.region")}}</label>
                                        <div class="form-control">
                                            <div v-if="realEstate && realEstate.region">
                                                <strong>{{ realEstate.region.name }}</strong>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.address")}}</label>
                                        <div class="form-control">
                                            <div v-if="realEstate && realEstate.address">
                                                <strong>{{ realEstate.address }}</strong>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("finance.field.phoneNumber")}}</label>
                                        <div class="form-control">
                                            <div v-if="realEstate && realEstate.apiOrderDto">
                                                <strong>{{ realEstate.apiOrderDto.mobilePhone }}</strong>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
      <CadastreDetailsModal @handle-accept="handleAcceptCadastreDetails" @handle-refresh="handleRefreshCadastreDetails" :processing.sync="processing"/>
      <ClientDataModal @handle-accept="handleAcceptClientData" @handle-refresh="handleRefreshClient" :owner.sync="owner" :processing.sync="processing"/>
    </div>
</template>

<script>

    import PreviewDropZoneEAppraisal from "@/views/real-estate/PreviewDropZoneEAppraisal";
    import PreviewDropZone from '@/views/real-estate/PreviewDropZone'
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import {minLength, requiredUnless} from 'vuelidate/lib/validators';
    import RealEstateLocationMap from './RealEstateLocationMap'
    import initFilterModel from '@/shared/filter';
    import CadastreFixErrorModal from "@/components/cadastre/CadastreFixErrorModal.vue";
    import RealEstateDropZone from "@/views/real-estate/RealEstateDropZone.vue";
    import CadastreDetailsModal from "@/components/cadastre/CadastreDetailsModal.vue";
    import ClientDataModal from "@/components/client/ClientDetailsModal.vue";

    export default {
        name: "ERealEstateView",
        components: {
          ClientDataModal,
          CadastreDetailsModal,
          RealEstateDropZone,
          CadastreFixErrorModal,
          PreviewDropZone,
          PreviewDropZoneEAppraisal,
          'b-modal': bModal,
          RealEstateLocationMap
        },
        data() {
            return {
                processing: false,
                showAssignment: false,
                show: false,
                realEstate: {
                    employee: {},
                    createdBy: {},
                    apiOrderDto: {},
                    reasonDesc: '',
                    evlContractAmount: 0,
                    prepayment: 0,
                    photos: []
                },
                employees: [],
                agents: [],
                goalTypesCommon: ['Predge', 'Sale', 'DeterminingValue', 'FormationStatutoryFund', 'Losses'],
                target: null,
                cadastreDetailsData: null,
                owner: null,
                filter: initFilterModel()
            }
        },
        validations()  {
            return {
                realEstate: {
                    employee: {
                        id: {
                            required: requiredUnless(() => {
                                return !(this.realEstate.status !== 'NotReady' && !this.isSourceEMonitoring);
                            })
                        }
                    },
                    createdBy: {
                        required: requiredUnless(() => {
                            return !(this.realEstate.status === 'NotReady');
                        })
                    },
                    buildings: {
                      $each: {
                        photos: {
                          required: requiredUnless(()=> {
                            return !this.isSourceEMonitoring
                          }),
                          minLength: minLength(1)
                        }
                      }
                    }
                }
            }
        },
        computed: {
          isOwnerTypePhysical() {
            return !!(this.realEstate.owner && this.realEstate.owner.type && this.realEstate.owner.type === 'Physical');
          },
          isGoalTypeCommon() {
            return this.isGoalType(this.goalTypesCommon);
          },
          isOwnerTypeLegal() {
            return !!(this.realEstate.owner && this.realEstate.owner.type && this.realEstate.owner.type === 'Legal');
          },
          isPrivatizationZero() {
            return this.isGoalType(['PrivatizationZero']);
          },
          isPrivatizationSimple() {
            return this.isGoalType(['Privatization']);
          },
          isOrgTypeMib() {
            return !!(this.realEstate.owner && this.realEstate.owner.organizationType && this.realEstate.owner.organizationType === 'BUREAU_OF_COMPULSORY_EXECUTION');
          },
          isMinContractAmount() {
            return this.realEstate.evlContractAmount >= 120000;
          },
          isCadastreFixError() {
            return this.realEstate.data && this.realEstate.data.values && (this.realEstate.data.values.getNewCadastre || this.realEstate.data.values.isCadastreError)
          },
          canRemoveFile() {
            return this.canSave && this.hasPermission('REAL_ESTATE_IMAGE_DELETE');
          },
          canSave() {
            return this.realEstate.status && this.realEstate.status === 'Pending';
          },
          isSourceEMonitoring() {
            return  this.realEstate.source === 'API_E_MONITORING'
          }
        },
        methods: {
            init() {
                const vm = this;
                const id = this.$route.params.id;
                let category = '';
                if (this.$route && this.$route.meta && this.$route.meta.category && this.$route.meta.category.length > 0) {
                    category = this.$route.meta.category;
                }
                const promises = [
                    this.$http.get('admin/real-estate/init/' + ((category && category.length > 0) ? category : 'na') + '/' + ((id && id > 0) ? id : '0'))
                ];
                if (id && id > 0){
                    promises.push(this.$http.get('/real-estate/' + id));
                }

                Promise.all(promises).then(function (values) {
                    const initData = values[0].data;
                    vm.employees = initData.employees;

                    if (values.length >= 2) {
                        const editData = values[1].data;
                        if (!editData.employee) {
                            editData.employee = {};
                        }
                        vm.realEstate = editData;

                        if (editData.province && editData.status === 'NotReady') {
                            vm.filter.province = editData.province;
                        }
                    }
                });
            },
            isGoalType(goalTypeCodes) {
                return !!(this.realEstate.evlGoalType && goalTypeCodes && goalTypeCodes.indexOf(this.realEstate.evlGoalType) >= 0);
            },
            applyAppraisal(status) {
              if (this.isSourceEMonitoring) {
                this.$v.$touch();
                if (this.$v.$invalid) {

                  this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: this.$t('building.field.photosToSubmit'),
                    type: 'warning'
                  })
                  return;
                }
                this.save()

              } else {
                if (this.realEstate.evlContractAmount < 120000 && !this.isOrgTypeMib) {
                  this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: this.$t('Контракт сўмма 120 000 сўмдан кам бўлмаслиги керак!'),
                    type: 'warning'
                  });
                  return;
                }

                if (this.realEstate.prepayment && !(this.realEstate.prepayment >= 0 && this.realEstate.prepayment <= 100)) {
                  this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: this.$t('Олдиндан тўлов фоизи 0% дан 100% гача!'),
                    type: 'warning'
                  });
                  return;
                }
                this.assignedToEvaluator(status)
              }
            },
            assignedToEvaluator(status) {

              this.processing = true;
              this.$http.post('admin/e-appraisal/real-estate/status/AssignedToEvaluator',  {
                realEstateId: this.realEstate.id,
                status: status,
                target: this.target,
                evlContractAmount: this.realEstate.evlContractAmount,
                prepayment: this.realEstate.prepayment
              }).then(res => {
                if (res && res.data && res.data.status === 'SUCCESS') {
                  this.showAssignment = false;
                  this.$swal({
                    title: this.$t('messages.common.success'),
                    text: this.$t('messages.realEstate.statusSuccess'),
                    type: 'success'
                  });
                  this.realEstate.status = status;
                } else {
                  this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: this.$t(res.data.message),
                    type: 'warning'
                  });
                  this.showAssignment = false;
                }
                this.processing = false;
              }, () => {
                this.$swal({
                  title: this.$t('messages.common.error'),
                  text: this.$t('messages.realEstate.statusError'),
                  type: 'error'
                });
                this.showAssignment = false;
                this.processing = false;
              })
            },
            rejectAppraisal(status) {
                if (this.realEstate.reasonDesc) {
                    this.processing = true;
                    this.$http.post('admin/real-estate/status/reject', {
                        realEstateId: this.realEstate.id,
                        status: status,
                        reasonDesc: this.realEstate.reasonDesc
                    }).then(res => {
                        if (res && res.data && res.data.status === 'SUCCESS') {
                            this.show = false;
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.realEstate.statusSuccess'),
                                type: 'success'
                            });
                            this.realEstate.status = status;
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: this.$t('messages.realEstate.statusWarning'),
                                type: 'warning'
                            });
                            this.show = false;
                        }
                        this.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.realEstate.statusError'),
                            type: 'error'
                        });
                        this.show = false;
                        this.processing = false;
                    })
                } else {
                    this.$swal({
                        title: 'Хабар!',
                        text: 'Бекор қилиш сабабини киритинг!',
                        type: 'warning'
                    });
                }
            },
            showReject() {
                this.realEstate.reasonDesc = '';
                this.show = true;
            },
            rejectModalHide() {
                this.show = false;
            },
            deletedRealEstate() {
                // this.$swal({
                //     title: this.$t('messages.common.warning'),
                //     text: this.$t('messages.realEstate.deleteConfirm'),
                //     type: 'warning',
                //     showCancelButton: true,
                //     confirmButtonColor: '#dd3333',
                //     confirmButtonText: 'Ўчириш',
                //     cancelButtonText: 'Бекор қилиш'
                //     // cancelButtonColor: '#dd3333'
                // }).then((result) => {
                //     if (result.value) {
                //         this.$http.delete('admin/real-estate/' + this.realEstate.id)
                //         .then((res) => {
                //             if (res && res.data && res.data.status === 'SUCCESS') {
                //                 this.$swal({
                //                     title: this.$t('messages.common.success'),
                //                     text: this.$t('messages.realEstate.deleteSuccess'),
                //                     type: 'success'
                //                 });
                //             } else {
                //                 this.$swal({
                //                     title: this.$t('messages.common.warning'),
                //                     text: res.data.message,
                //                     type: 'warning'
                //                 });
                //             }
                //             this.processing = false;
                //         }, () => {
                //             this.$swal({
                //                 title: this.$t('messages.common.error'),
                //                 text: this.$t('messages.realEstate.deleteError'),
                //                 type: 'error'
                //             });
                //             this.processing = false;
                //         });
                //     }
                // });
            },
            onUsersSearch(searchTxt, loading) {
                loading(true);
                this.agents = [];
                this.filter.search = searchTxt;
                this.$http.post('user/agent', this.filter)
                    .then(res => {
                        this.agents = res.data.data;
                        loading(false);
                        this.filter.search = '';
                    }, err => {
                        console.log(err);
                        loading(false);
                    });
            },
            onUsersFocus() {
                this.agents = [];
                this.filter.search = '';
                this.$http.post('user/agent', this.filter)
                    .then(res => {
                        this.agents = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            bindAgent() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.processing = true;
                this.$http.post('admin/e-appraisal/real-estate/bind-agent', this.realEstate).then(res => {
                    if (res && res.data && res.data.status === 'SUCCESS') {
                        this.$swal({
                            title: this.$t('messages.common.success'),
                            text: this.$t('messages.realEstate.statusSuccess'),
                            type: 'success'
                        });
                        this.$router.push('/e-appraisal/real-estate/list');
                    } else {
                        this.$swal({
                            title: this.$t('messages.common.warning'),
                            text: this.$t(res.data.message),
                            type: 'warning'
                        });
                    }
                    this.processing = false;
                }, () => {
                    this.$swal({
                        title: this.$t('messages.common.error'),
                        text: this.$t('messages.realEstate.statusError'),
                        type: 'error'
                    });
                    this.processing = false;
                })
            },
            sendFixError() {
              this.$eventBus.$emit('showCadastreFixErrorModal');
            },
            handleFixErrorSuccess() {
              this.$router.push('/e-appraisal/real-estate/list');
              this.$eventBus.$emit('eRealEstateChanged');
            },
            showCadastreDetail() {
              this.$http.get('/admin/v3/real-estate/' + this.realEstate.requestId)
                  .then(res => {
                    if (res.data) {
                      let resData = res.data;

                      this.cadastreDetailsData = resData.cadastreInfo
                      this.owner = resData.clientInfo;

                      this.$eventBus.$emit('showCadastreDetailsModal', this.cadastreDetailsData);
                    }
                  }, err => {
                    console.log(err)
                  });
            },
            handleAcceptCadastreDetails() {
              this.realEstate.isAcceptCadastre = true
            },
            handleRefreshCadastreDetails() {
              this.realEstate.getNewCadastre = true
            },

            handleAcceptClientData() {
              this.realEstate.isAcceptOwner = true
            },

            handleRefreshClient() {
              this.realEstate.getNewOwner = true
            },
            save() {
              this.$v.$touch();
              if (this.$v.$invalid) {
                return;
              }

              // this.processing = true;
              // this.$http.post('mobile/real-estate-act-add-photo/save', this.realEstate).then(res => {
              //   if (res && res.data && res.data.status === 'SUCCESS') {
              //
              //     this.assignedToEvaluator('AssignedToEvaluator')
              //
              //    /* this.$swal({
              //       title: this.$t('messages.common.success'),
              //       text: this.$t('messages.realEstate.statusSuccess'),
              //       type: 'success'
              //     }); */
              //     // this.$router.push('/e-appraisal/real-estate/list');
              //   } else {
              //     this.$swal({
              //       title: this.$t('messages.common.warning'),
              //       text: this.$t(res.data.message),
              //       type: 'warning'
              //     });
              //   }
              //   this.processing = false;
              // }, () => {
              //   this.$swal({
              //     title: this.$t('messages.common.error'),
              //     text: this.$t('messages.realEstate.statusError'),
              //     type: 'error'
              //   });
              //   this.processing = false;
              // })
            }
        },
        created() {
            this.filter.province = null;
            this.init();
        }
    }
</script>

<style scoped>

</style>